import Cookies from 'js-cookie';
import { randomNumberRange } from '@/helpers/core';

type PixelValues = {
  fbp: string | null;
  fbc: string | null;
};

type BuilderFunction = (fbclid?: string) => string | null;

enum PixelCookie {
  FBC = '_fbc',
  FBP = '_fbp',
}

function valueBasePart() {
  return `fb.1.${Date.now()}`;
}

const BUILDERS: Dictionary<BuilderFunction> = {
  [PixelCookie.FBP]: () => {
    return `${valueBasePart()}.${randomNumberRange(100000000, 2000000000)}`;
  },
  [PixelCookie.FBC]: (fbclid?: string) => {
    if (!fbclid) {
      return null;
    }

    return `${valueBasePart()}.${fbclid}`;
  },
};

export default class PixelService {
  private static values: PixelValues = {
    fbp: null,
    fbc: null,
  };

  public static initCookies(fbclid: string) {
    const fbp = this._restoreOrBuildValue(PixelCookie.FBP);
    const fbc = this._restoreOrBuildValue(PixelCookie.FBC, fbclid);

    Object.assign(this.values, { fbc, fbp });
  }

  public static getValues(): PixelValues {
    return this.values;
  }

  private static _restoreOrBuildValue(code: string, fbclid?: string): string | null {
    const value = (!fbclid && this._getValue(code)) || this._buildValue(code, fbclid);

    if (value) {
      this._saveValue(code, value);
    } else {
      this._removeValue(code);
    }

    return value;
  }

  private static _buildValue(code: string, fbclid?: string): string | null {
    const builder = BUILDERS[code];

    if (!builder) {
      return null;
    }

    return builder(fbclid);
  }

  private static _getValue(code: string): string | undefined {
    return Cookies.get(code);
  }

  private static _saveValue(code: string, value: string) {
    Cookies.set(code, value, { expires: 60, SameSite: 'lax' });
  }

  private static _removeValue(code: string) {
    Cookies.remove(code);
  }
}
